import { Helmet } from 'react-helmet';

const SEOHead = ({ 
  title = "Teranga Global Legal", 
  description = "Cabinet de conseil juridique et d'affaires à Thiès, Sénégal. Expertise en création d'entreprise, droit des affaires, accompagnement entrepreneurial.",
  path = "",
  type = "website"
}) => {
  const siteUrl = "https://teranga-conseil.emergent.host";
  const fullUrl = `${siteUrl}${path}`;
  const fullTitle = title === "Teranga Global Legal" 
    ? "Teranga Global Legal | Cabinet de Conseil Juridique au Sénégal"
    : `${title} | Teranga Global Legal`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={fullUrl} />
      
      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      
      {/* Twitter */}
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
    </Helmet>
  );
};

export default SEOHead;
